import { render, staticRenderFns } from "./create-portfolio.vue?vue&type=template&id=6aa1601c&scoped=true&lang=pug&"
import script from "./create-portfolio.vue?vue&type=script&lang=js&"
export * from "./create-portfolio.vue?vue&type=script&lang=js&"
import style0 from "./create-portfolio.vue?vue&type=style&index=0&id=6aa1601c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa1601c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VFabTransition,VImg,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VRow})
